import { Box, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { GetApp } from '@mui/icons-material';
import Tooltip from '../tooltip';

interface Props {
  value: string;
  label: string;
  popup: {
    setStateCallback(state: boolean): void;
    setMsgCallback(msg: string): void;
  };
}
const DownloadSecrets = ({ value, label, popup }: Props) => {
  const theme = useTheme();

  const downloadHref = () => {
    const blobInstance = new Blob([value], { type: 'text/plain' });

    return URL.createObjectURL(blobInstance);
  };

  const handleDownload = () => {
    popup.setMsgCallback(`${label}.txt file downloaded`);
    popup.setStateCallback(true);
  };

  return (
    <Box
      height={theme.customComponents.form.size.large}
      display="flex"
      justifyContent="flex-end"
      data-testid="button-download-secrets"
    >
      <Tooltip title="Download">
        <IconButton
          href={downloadHref()}
          aria-label="download"
          download={`${label}.txt`}
          onClick={handleDownload}
          size="large"
        >
          <GetApp />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default DownloadSecrets;
